<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Printer Setting</h5>
                    <form class="forms-sample">
                        <b-form-group label="Device Id">
                            <b-form-input v-model="printer.deviceId" 
                                          type="text" 
                                          placeholder="Name">
                            </b-form-input>
                        </b-form-group>
                        <b-button variant="success" 
                                  class="mr-2"
                                  v-on:click="handleBtnSave">
                                  Add
                        </b-button>
                        <b-button variant="light" 
                                  v-on:click="handleBtnCancel">
                                  Cancel
                        </b-button>
                    </form>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapState } from'vuex'
export default{
    name: 'payment',
    computed : {
        ...mapState({
                printer : state => state.printer.printer
        })
    },
    methods: {
        handleBtnSave() {

        },
        handleBtnCancel() {
            this.$router.push('/'); 
        }
    },
    created() {

    },
}
</script>